<div class="ui-drawer-content">
  <ng-content></ng-content>
</div>
